/* heading-item.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import "./heading-item.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { HeadingItem as MenuHeadingItem } from '@atlaskit/menu';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';
var styles = {
  headingItem: "_18zru2gc"
};

/**
 * __Heading item__
 *
 * Available for advanced use cases, for most situations providing a `title` to `section` should be enough.
 *
 */
var HeadingItem = function HeadingItem(props) {
  var _useShouldNestedEleme = useShouldNestedElementRender(),
    shouldRender = _useShouldNestedEleme.shouldRender;
  if (!shouldRender) {
    return null;
  }

  // @ts-expect-error - Although this isn't defined on props it is available because we've used
  // spread props below and on the jsx element in MenuHeadingItem.
  var UNSAFE_className = props.className;
  return /*#__PURE__*/React.createElement(MenuHeadingItem
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props, @repo/internal/react/no-unsafe-overrides
  , _extends({}, props, {
    // @ts-expect-error
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
    className: ax([styles.headingItem, UNSAFE_className])
    // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
  }));
};
export default HeadingItem;